import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const ArrowRightFilled = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="130" height="130" viewBox="0 0 130 130">
      <g id="Groupe_5538" data-name="Groupe 5538" transform="translate(228 605) rotate(180)">
        <circle id="Ellipse_462" data-name="Ellipse 462" cx="65" cy="65" r="65" transform="translate(98 475)" fill="#fff"/>
        <path id="Tracé_5723" data-name="Tracé 5723" d="M5114.493,17443.213l-25.066,25.064,25.066,25.068" transform="translate(-4945.074 -16928.279)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="6"/>
      </g>
    </svg>
  </SvgIcon>
);

export default ArrowRightFilled;